import { render, staticRenderFns } from "./cSocialTable.vue?vue&type=template&id=69e89a62&"
import script from "./cSocialTable.vue?vue&type=script&lang=js&"
export * from "./cSocialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports